<template>
	<div>
		<footer class="footer">
			<div class="content">
				<div class="columns footer-columns">
					<div class="column">
						<!-- BTS Logo -->
						<img
							src="../assets/images/BTS-Logo-Square.png"
							alt="British Transplantation Society Logo"
						/>
					</div>
					<div class="column">
						<!-- Twitter Widget -->
						<img
							src="https://bts.org.uk/wp-content/uploads/2016/07/TVoTitUK_Foot.png"
						/>
						<br /><br />
						<a
							class="twitter-timeline"
							data-height="300"
							data-theme="dark"
							data-link-color="#E81C4F"
							href="https://twitter.com/BTStransplant?ref_src=twsrc%5Etfw"
							>Tweets by BTStransplant</a
						>
					</div>
					<div class="column">
						<img
							src="../assets/images/NICE-Accredited-Logo.jpg"
							alt="Nice Accredited Logo"
						/>
					</div>
				</div>
			</div>
		</footer>
		<!-- Secondary Footer -->
		<div class="container-fluid secondary-footer">
			<div class="columns secondary-footer-columns">
				<div class="column">
					<p>© Copyright British Transplantation Society</p>
				</div>
				<div class="column has-text-right is-hidden-touch">
					<a
						href="https://bts.org.uk/about-bts/terms-of-use/"
						target="_blank"
						class="secondary-footer-link"
						>Terms of Use</a
					>
					<a
						href="https://bts.org.uk/about-bts/privacy-policy/"
						target="_blank"
						class="secondary-footer-link"
						>Privacy Policy</a
					>
					<a
						href="https://bts.org.uk/about-bts/acceptable-use-policy/"
						target="_blank"
						class="secondary-footer-link"
						>Acceptable Use Policy</a
					>
					<a
						href="https://bts.org.uk/contact/"
						target="_blank"
						class="secondary-footer-link"
						>Contact</a
					>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Footer',
};
</script>

<style>
.footer {
	background-color: #0a1628 !important;
	color: #ffffff !important;
	padding-bottom: 3rem !important;
}

.footer-columns {
	align-items: center;
	text-align: center;
}

.secondary-footer {
	background-color: #050f1e !important;
	color: #ffffff !important;
	padding: 0rem 3rem 0rem 3rem;
}

.secondary-footer a {
	color: #ffffff;
	margin-left: 1rem;
	padding-left: 1rem;
	border-left: 1px solid;
}

.secondary-footer a:first-child {
	border-left: none;
}

.secondary-footer a:hover {
	color: #b4cad9;
	text-decoration: underline;
}
</style>
